// extracted by mini-css-extract-plugin
export var boldText = "_8o-4";
export var checkboxContainer = "_8o-6";
export var closeIcon = "_8o-i";
export var container = "_8o-0";
export var drawer = "_8o-8";
export var drawerContent = "_8o-9";
export var extraSmallText = "_8o-5";
export var fulfillmentGroupTable = "_8o-e";
export var largeText = "_8o-3";
export var loadingSpinnerContainer = "_8o-j";
export var mediumText = "_8o-2";
export var narrow = "_8o-f";
export var notificationLink = "_8o-l";
export var packageCheckIconContainer = "_8o-7";
export var slideoutHeaderActions = "_8o-g";
export var slideoutHeaderActionsShifted = "_8o-h";
export var slideoutHeaderContainer = "_8o-a";
export var slideoutModal = "_8o-c";
export var stickyHeaderWrapper = "_8o-b";
export var table = "_8o-k";
export var tableContainer = "_8o-d";
export var tertiaryText = "_8o-1";